/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { removeUserFromOrg } from './user.remove.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  userId: undefined,
  dialog: { open: false },
  error: undefined,
};

/* Slice */
export const removeUserFromOrgSlice = createSlice({
  name: 'removeUserFromOrg',
  initialState,
  reducers: {
    toggleRemoveUserDialog(state, action) {
      state.dialog.open = action.payload;
    },
    updateUserId(state, action) {
      state.userId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(removeUserFromOrg.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(removeUserFromOrg.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.users = action.payload;
        state.dialog.open = false;
        state.error = undefined;
      })
      .addCase(removeUserFromOrg.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectRemoveUserFromOrgSlice = state => state[removeUserFromOrgSlice.name];

export const selectDialog = createSelector(selectRemoveUserFromOrgSlice, s => s.dialog);
export const selectStatus = createSelector(selectRemoveUserFromOrgSlice, s => s.status);
export const selectUserId = createSelector(selectRemoveUserFromOrgSlice, s => s.userId);

/* Actions */
export const { toggleRemoveUserDialog, updateUserId } = removeUserFromOrgSlice.actions;
